import { ParamsByObsType } from "../api/EvalWorkflowApi";
import GrammarApi, { ParamType } from "../api/GrammarApi";
import LocalStorageService from "../service/LocalStorageService";

export type ParamTypesByObsType = Record<string, ParamType[]>;

export async function getParamTypes(
  paramsByObsType: ParamsByObsType = {},
  grammarApi: GrammarApi,
  obsTypes: string[]
): Promise<ParamTypesByObsType> {
  const supportedObsTypes = Object.keys(paramsByObsType);

  if (supportedObsTypes.length === 0) {
    return {};
  }

  const obsTypesWithParams = supportedObsTypes.filter((obsType) => obsTypes.includes(obsType));

  if (obsTypesWithParams.length === 0) {
    return {};
  }

  try {
    const result: ParamTypesByObsType = {};
    for (const obsType of obsTypesWithParams) {
      const obsTypeParams = await Promise.all(
        paramsByObsType[obsType].map(({ code }) => LocalStorageService.getParamTypeAsync(code, grammarApi))
      );

      result[obsType] = obsTypeParams.map((param) => ({
        ...param,
        required: !!paramsByObsType[obsType].find(({ code }) => param.code === code)?.required,
      }));
    }

    return result;
  } catch (err) {
    console.error("Could not load paramTypes");
    console.debug(err);
  }

  return {};
}
